// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"fc7a7f35","179":"a861d20c","228":"9a8d47dc","272":"8ec62dfe","352":"c9303d98","549":"754ac649","666":"b2c655b9","816":"6ca38696","930":"5b398b50","996":"31794dfa"}[chunkId] + ".chunk.js";
};